<template>
  <div class="page page-catalog">
    <!-- <img style="width: 100%; margin-bottom: 30px;" :src="getDefaultImage(shop.banner_default)" alt=""> -->
    <div class="banner">
      <div class="banner__top">
        <div class="banner__logo">
          <img :src="getDefaultImage(shop.logo)" alt="">
          <a href="#" style="display: flex; align-items: center; margin-top: 15px;" @click="isReviewsPopupOpen = true">
            <SfRating :max="5" :score="shop.rating" icon="star" />
            <span style="margin-left: 10px;">({{ shop.totalReviews }})</span>
          </a>
        </div>
        <div class="banner__banner-wrapper banner__middle">
          <div>
            <SfProperty
              name="Телефон"
              v-if="shop.phone"
              value=""
              class="product__property"
              style="margin-bottom: 5px;"
            >
              <template #value>
                <span
                  v-if="!isPhoneClicked"
                  class="sf-property__value"
                  style="cursor: pointer;"
                  @click="() => isPhoneClicked = true"
                >
                  +998*********
                  <button class="special-button" style=" padding: 5px">Показать номер</button>
                </span>
                <a class="sf-property__value" v-else-if="shop.phone" :href="`tel:${shop.phone}`">{{shop.phone}}</a>
                <span v-else class="sf-property__value">Отсутсвует</span>
              </template>
            </SfProperty>
            <SfProperty
              name="Телефон"
              v-if="shop.phone2"
              value=""
              class="product__property"
              style="margin-bottom: 5px;"
            >
              <template #value>
                <span
                  v-if="!isPhoneClicked2"
                  class="sf-property__value"
                  style="cursor: pointer;"
                  @click="() => isPhoneClicked2 = true"
                >
                  +998*********
                  <button class="special-button" style=" padding: 5px">Показать номер</button>
                </span>
                <a class="sf-property__value" v-else-if="shop.phone2" :href="`tel:${shop.phone2}`">{{shop.phone2}}</a>
                <span v-else class="sf-property__value">Отсутсвует</span>
              </template>
            </SfProperty>  
          </div>
          
          <div class="work_time" style="margin-bottom: 5px;">
            {{ shop.work_time }}
          </div>
          <div
            class="location"
            style="margin-bottom: 5px;"
            v-html="shop.map || ''"
          >
            <!-- {{ shop.address }} -->
            <!-- <img width="100%" 
             style="max-width: 500px;"
              :src="`https://maps.googleapis.com/maps/api/staticmap?center=
              ${(shop.coordinate && shop.coordinate[0] && shop.coordinate[0].lat) || ''},
              ${(shop.coordinate && shop.coordinate[0] && shop.coordinate[0].lng) || ''}
              &zoom=16&size=640x300&maptype=roadmap&markers=color:blue%7Clabel:S%7C
              ${(shop.coordinate && shop.coordinate[0] && shop.coordinate[0].lat) || ''},
              ${(shop.coordinate && shop.coordinate[0] && shop.coordinate[0].lng) || ''}
              &markers=color:green%7Clabel:G%7C40.711614,-74.012318&markers=color:red%7Clabel:C%7C40.718217,-73.998284&key=AIzaSyCTVSlrA84Qt0yDVWcADwa9OVmgVNS-l0k`" alt=""> -->
          </div>
        </div>
      </div>
      <div class="banner__bottom">
        {{ descriptionPart() }}
        <br>
        <a v-if="!descAll" @click="descAll = true" href="#">Читать далее...</a>
      </div>
    </div>

    <div class="search" style="display: flex;">
      <SfInput
        label="Поиск внутри магазина"
        type="search"
        v-model="filtersValues.search"
        style="flex: 1;"
      />
      <SfButton @click="searchProducts" >Поиск</SfButton>
    </div>
    
    <div class="navbar section">
      <div class="navbar__aside desktop-only">
        <SfHeading :level="3" title="Каталог" class="navbar__title" />
      </div>
      <div class="navbar__main">
        <SfButton
          class="sf-button--text navbar__filters-button"
          aria-label="Фильтры"
          @click="toggleFilterSidebar"
        >
          <SfIcon
            size="24px"
            color="dark-secondary"
            icon="filter2"
            class="navbar__filters-icon"
          />
           Фильтры
        </SfButton>
        <div class="navbar__sort desktop-only">
          <span class="navbar__label">Сортировать по:</span>
          <SfSelect
            :value="sortBy.selected"
            placeholder="Выбрать сортировку"
            class="navbar__select"
            @input="changeSorting"
          >
            <SfSelectOption
              v-for="option in sortBy.options"
              :key="option.id"
              :value="option.id"
              class="sort-by__option"
              >{{ option.value }}</SfSelectOption
            >
          </SfSelect>
        </div>
        <div class="smartphone-only" @click="toggleCategoriesSidebar" style="display: flex; align-items: center; justify-content: flex-start;">
          <SfIcon
            class="navbar__view-icon"
            :color="isCategoryGridView ? 'black' : 'dark-secondary'"
            icon="tiles"
            size="12px"
            role="button"
            aria-label="Открыть каталог"
            :aria-pressed="isCategoriesSidebarOpen"
            style="margin-right: 5px;"
          />
          <span class="navbar__view-label">Каталог</span>
        </div>
        <div class="navbar__counter">
          <span class="navbar__label desktop-only">Товаров найдено: </span>
          <span class="desktop-only">{{ pagination.totalItems }}</span>
          <span class="navbar__label smartphone-only">{{ pagination.totalItems }} Товаров</span>
        </div>
      </div>
    </div>
    <div class="main section">
      <div class="sidebar sidebar-main desktop-only">
        <!-- <SfCheckbox
          name="metal"
          label="Серебро"
          value="silver"
          v-model="isSilver"
        /> -->
        <SfLoader :class="{ loading }" :loading="loading">
          <SfAccordion :open="categoryTree.items ? categoryTree.items[0].label : ''" :show-chevron="false">
            <SfAccordionItem
              v-for="(cat, i) in categoryTree && categoryTree.items"
              :key="i"
              :header="cat.label"
            >
              <template>
                <SfList class="list">
                  <SfListItem class="list__item">
                    <SfMenuItem
                      :data-cy="`category-link_subcategory_${cat.slug}`"
                      :label="cat.label"
                    >
                      <template #label>
                        <router-link
                        :to="{ name: 'shop', params: { shop: $route.params.shop } }"
                        :class="cat.isCurrent ? 'sidebar--cat-selected' : ''"
                        @click.native="getProducts"
                        >
                          Все
                        </router-link>
                      </template>
                    </SfMenuItem>
                  </SfListItem>
                  <SfListItem
                    class="list__item"
                    v-for="(subCat, j) in cat.items"
                    :key="j"
                  >
                    <SfMenuItem
                      :data-cy="`category-link_subcategory_${subCat.slug}`"
                      :label="subCat.name"
                      :count="subCat.shop_count || ''"
                    >
                      <template #label="{ label }">
                        <router-link
                          :to="{ name: 'shop', params: { shop: $route.params.shop, category: subCat.slug } }"
                          :class="subCat.isCurrent ? 'sidebar--cat-selected' : ''"
                          @click.native="getProducts"
                        >
                          {{ label }}
                        </router-link>
                      </template>
                    </SfMenuItem>
                  </SfListItem>
                </SfList>
              </template>
            </SfAccordionItem>
          </SfAccordion>
        </SfLoader>
      </div>
      <SfLoader :class="{ loading }" :loading="loading">
        <div class="products" v-if="!loading && products.length > 0">
          <transition-group
            appear
            name="products__slide"
            tag="div"
            class="products__grid"
          >
            <template v-for="(product, i) in products">
                <Product
                  :key="product.slug"
                  :product="product"
                  :style="{ '--index': i }"
                  :isOnWishlist="isOnWishlist"
                  @toggleProductWishlist="toggleProductWishlist"
                />
              <div style="flex: 1 100%;" v-if="(i+1) % 10 == 0" :key="i">
                <SfBanner
                  v-if="pagination.currentPage == 1 && shop[`banner_${i >= 29 ? 3 : i >= 19 ? 2 : 1}`]"
                  :image="{
                    desktop: getDefaultImage(shop[`banner_${i >= 29 ? 3 : i >= 19 ? 2 : 1}`]),
                    mobile: getDefaultImage(shop[`banner_mobile_${i >= 29 ? 3 : i >= 19 ? 2 : 1}`]),
                  }"
                  style="--banner-background-size: contain;"
                />
              </div>
            </template>
          </transition-group>
          <SfPagination
            v-if="!loading"
            data-cy="category-pagination"
            class="products__pagination"
            v-show="pagination.totalPages > 1"
            :current="pagination.currentPage"
            :total="pagination.totalPages"
            :visible="5"
          >
            <template #number="{ page }">
              <a @click="setCurrentPage(page)" :class="{ active: pagination.currentPage === page }" class="sf-link sf-pagination__item" style="outline: none; cursor: pointer;"> {{ page }} </a>
            </template>
            <template #prev="{ isDisabled }">
              <button class="special-button" @click="() => setCurrentPage(pagination.currentPage - 1)" :disabled="isDisabled ? true : false">пред.</button>
            </template>
            <template #next="{ isDisabled }">
              <button class="special-button" @click="() => setCurrentPage(pagination.currentPage + 1)" :disabled="isDisabled ? true : false">след.</button>
            </template>
          </SfPagination>
          <div
            v-show="pagination.totalPages > 1"
            class="products__show-on-page"
          >
            <span class="products__show-on-page__label">Отобразить на странице:</span>
            <SfSelect
              :selected="pagination.itemsPerPage"
              class="products__items-per-page"
              @change="changeItemsPerPage"
            >
              <SfSelectOption
                v-for="option in pagination.pageOptions"
                :key="option"
                :value="option"
                class="products__items-per-page__option"
              >
                {{ option }}
              </SfSelectOption>
            </SfSelect>
          </div>
        </div>
        <div style="display: flex; min-height: 50vh; justify-content: center; width: 100%; align-items: center;" v-else-if="products.length == 0" class="product-not-found">
          
          <span class="navbar__label">Товаров не найдено...</span> 
        </div>
      </SfLoader>
    </div>
    <SfSidebar
      :visible="isFilterSidebarOpen"
      title="Фильтры"
      class="sidebar-filters"
      @close="toggleFilterSidebar"
    >
      <div class="filters desktop-only">
        <div v-for="(filter, i) in filters" :key="i">
          <SfHeading
            :level="4"
            :title="filter.label"
            class="filters__title sf-heading--left"
            :key="`filter-title-${filter.id}`"
          />
            <div
              v-if="filter.type === 'color'"
              class="filters__colors"
              :key="`${filter.id}-colors`"
            >
              <SfColor
                v-for="option in filter.options"
                :key="`${filter.id}-${option.value}`"
                :color="option.value"
                :selected="isFilterSelected(filter, option)"
                class="filters__color"
                @click="() => selectFilter(filter, option)"
              />
            </div>
            <div v-else>
              <SfFilter
                v-for="option in filter.options"
                :key="`${filter.id}-${option.value}`"
                :label="option.name"
                :selected="isFilterSelected(filter, option)"
                class="filters__item"
                @change="() => selectFilter(filter, option)"
              />
            </div>
        </div>
        <div>
          <SfHeading
            :level="4"
            title="Цена"
            class="filters__title sf-heading--left"
            :key="`filter-title-price`"
          />
            <div>
              <vue-slider
                ref="slider2"
                v-model="filtersValues.price"
                :interval="100000"
                :min="0"
                :max="50000000"
                tooltip="always"
                ></vue-slider>
            </div>
        </div>
      </div>
      <SfAccordion class="filters smartphone-only">
        <div v-for="(filter, i) in filters" :key="i">
          <SfAccordionItem
            :key="`filter-title-${filter.id}`"
            :header="filter.label"
            class="filters__accordion-item"
          >
          <SfFilter
            v-for="option in filter.options"
            :key="`${filter.id}-${option.id}`"
            :label="option.name"
            :selected="isFilterSelected(filter, option)"
            class="filters__item"
            @change="selectFilter(filter, option)"
          />
          <div>
          <SfHeading
            :level="4"
            title="Цена"
            class="filters__title sf-heading--left"
            :key="`filter-title-price`"
          />
            <div>
              <vue-slider
                ref="slider1"
                v-model="filtersValues.price"
                :interval="100000"
                :min="0"
                :max="50000000"
                tooltip="always"
                ></vue-slider>
            </div>
        </div>
        </SfAccordionItem>
      </div>
      </SfAccordion>
      <template #content-bottom>
        <div class="filters__buttons">
          <SfButton
            class="sf-button--full-width"
            @click="applyFilters"
            >Готово</SfButton
          >
          <SfButton
            class="sf-button--full-width filters__button-clear"
            @click="clearFilters"
            >Очистить все</SfButton
          >
        </div>
      </template>
    </SfSidebar>
    <SfSidebar
      :visible="isCategoriesSidebarOpen"
      title="Каталог"
      class="sidebar-filters sidebar-filters-catalog"
      @close="toggleCategoriesSidebar"
    >
      <!-- <SfCheckbox
        name="metal"
        label="Серебро"
        value="silver"
        v-model="isSilver"
      /> -->
      <SfAccordion :show-chevron="false" :open="categoryTree.items ? categoryTree.items[0].label : ''">
        <SfAccordionItem
          v-for="(cat, i) in categoryTree && categoryTree.items"
          :key="i"
          :header="cat.label"
        >
          <template>
            <SfList class="list">
              <SfListItem class="list__item">
                <SfMenuItem
                  :data-cy="`category-link_subcategory_${cat.slug}`"
                  :label="cat.label"
                >
                  <template #label>
                    <router-link
                    :to="{ name: 'catalog' }"
                    :class="cat.isCurrent ? 'sidebar--cat-selected' : ''"
                    @click.native="getProducts"
                    >
                      Все
                    </router-link>
                  </template>
                </SfMenuItem>
              </SfListItem>
              <SfListItem
                class="list__item"
                v-for="(subCat, j) in cat.items"
                :key="j"
              >
                <SfMenuItem
                  :data-cy="`category-link_subcategory_${subCat.slug}`"
                  :label="subCat.name"
                  :count="subCat.shop_count || ''"
                >
                  <template #label="{ label }">
                    <router-link
                      :to="{ name: 'shop', params: { shop: $route.params.shop, category: subCat.slug } }"
                      :class="subCat.isCurrent ? 'sidebar--cat-selected' : ''"
                      @click.native="getProducts"
                    >
                      {{ label }}
                    </router-link>
                  </template>
                </SfMenuItem>
              </SfListItem>
            </SfList>
          </template>
        </SfAccordionItem>
      </SfAccordion>
    </SfSidebar>
    <ReviewsPopup :open="isReviewsPopupOpen" :reviews="shop.reviews" @close="isReviewsPopupOpen = false" />
  </div>
</template>

<script>
import axios from '../../shared/apiRequest'

import ReviewsPopup from '../../components/ReviewsPopup'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

import {
  SfSidebar,
  SfButton,
  SfList,
  SfIcon,
  SfHeading,
  SfMenuItem,
  SfFilter,
  SfBanner,
  SfPagination,
  SfAccordion,
  SfSelect,
  SfLoader,
  SfColor,
  SfProperty,
  SfInput,
  SfRating
  // SfCheckbox
} from '@storefront-ui/vue';

import filters from '@/shared/filters';
import categories from '@/shared/categories';

import Product from '../../components/Product'

import { createNamespacedHelpers } from 'vuex'
const { mapMutations, mapGetters } = createNamespacedHelpers('wishlist');

export default {
  name: "CatalogPage",

  components: {
    SfButton,
    SfSidebar,
    SfIcon,
    SfList,
    SfFilter,
    SfBanner,
    SfPagination,
    SfMenuItem,
    SfAccordion,
    SfSelect,
    SfLoader,
    SfColor,
    SfHeading,
    SfProperty,
    VueSlider,
    SfInput,
    Product,
    SfRating,
    ReviewsPopup
    // SfCheckbox
  },

  data() {
    return {
      isSilver: [],
      banners: [
        {
          background: '#ffffff',
          image: '/assets/homepage/bannerH.webp',
          link: 'catalog'
        },
        {
          background: '#2a2a34',
          image: '/assets/homepage/bannerA.webp',
          link: 'catalog'
        },
        {
          background: '#2a2a34',
          image: '/assets/homepage/bannerA.webp',
          link: 'catalog'
        },
      ],
      isPhoneClicked: false,
      isPhoneClicked2: false,
      isFilterSidebarOpen: false,
      isCategoriesSidebarOpen: false,
      isCategoryGridView: true,
      sortBy: {
        selected: "desc",
        options: [
          {
            id: "desc",
            value: "Сначало новые"
          },
          {
            id: "asc",
            value: "Сначало старые"
          },
        ]
      },
      pagination: {
        totalItems: 10,
        totalPages: 3,
        currentPage: 1,
        itemsPerPage: 5,
        pageOptions: [ 5, 10, 15]
      },
      loading: true,
      categoryTree: {
        items: [
          {
            slug: "new",
            label: "",
            count: 3,
            items: categories
          },
        ]
      },
      products: [
      ],
      filters,
      filtersValues: {
        metal: null,
        insert: null,
        'insert-color': null,
        carat: null,
        stone_cut: null,
        probe: null,
        forWho: null,
        style: null,
        type: null,
        size: null,
        length: null,
        price: [
          0, 50000000
        ],
        search: ''
      },
      shop: {
        title: '',
        banner: ''
      },
      isReviewsPopupOpen: false,
      descAll: false
    }
  },

  mounted() {
    if(this.$route.query.page) {
      this.pagination.currentPage = this.$route.query.page
    }

    this.getShop().then(() => {
      this.getCategories();
    });
    this.getProducts();
    this.isOnWishlist(1);
    this.getBanners();
  },

  watch: {
    'pagination.currentPage': function() {
      this.getProducts()
    },
    isSilver(to) {
      if(to.length > 0) {
        this.filtersValues.metal = 'silver'
      } else {
        this.filtersValues.metal = null
      }
      
      this.getProducts()
    }
  },

  methods: {
    ...mapMutations({
      toggleProductWishlist: 'ADD_PRODUCT'
    }),
    async getShop() {
      await axios.get(`/shop/${this.$route.params.shop}`)
          .then((result) => {
            const data = result.data;
            this.shop = data;
            console.log(data.coordinate)
            document.title = `${this.shop.name} - CityGold.uz`
            document.querySelector('meta[name="description"]').setAttribute("content", this.shop.description);
            document.querySelector('meta[property="og:image"]').setAttribute("content", `${process.env.VUE_APP_STORAGE}/${this.shop.logo}`);

            axios.post(`/analytics/${this.shop.id}`, {
              field: 'visits_total'
            })

            setTimeout(() => {
              axios.post(`/analytics/${this.shop.id}`, {
                field: 'views_shop'
              })
            }, 2000)

            let uniqueShops = localStorage.getItem('uniqueShops')
            const productShopId = this.shop.id

            if(uniqueShops) {
              uniqueShops = JSON.parse(uniqueShops)

              console.log(uniqueShops)

              if(!uniqueShops.includes(productShopId)) {
                uniqueShops.push(productShopId)
                localStorage.setItem('uniqueShops', JSON.stringify(uniqueShops))
                axios.post(`${process.env.VUE_APP_API_URL}/analytics/${productShopId}`, {
                  field: 'visits_unique'
                })
              }
            } else {
              uniqueShops = []

              uniqueShops.push(productShopId)
              localStorage.setItem('uniqueShops', JSON.stringify(uniqueShops))
              axios.post(`${process.env.VUE_APP_API_URL}/analytics/${productShopId}`, {
                field: 'visits_unique'
              })

            }
          })
          .catch((error) => {
            console.log(error)
          });
    },
    descriptionPart() {
      const desc = this.shop.description || ''
      return this.descAll ? this.shop.description : (desc.slice(0, 150) + '...');
    },
    getCategories() {
      axios.get(`/categories`, {
        params: {
          shop: this.shop.id
        }
      })
          .then((result) => {
            const data = result.data;
            const classic = []
            const casy = []

            data.forEach((category) => {
              if(category.slug.search('casy') !== -1) {
                if(category.name.search('Часы Мужские ') !== -1) {
                  category.name = category.name.split('Часы Мужские ')[0] + category.name.split('Часы Мужские ')[1];
                }
                if(category.name.search('Часы Женские ') !== -1) {
                  category.name = category.name.split('Часы Женские ')[0] + category.name.split('Часы Женские ')[1];
                }
                     
                casy.push(category)
              } else {
                classic.push(category)
              }
            })

            this.categoryTree.items[0].items = data;
            // if(casy.length > 0) {
            //   this.categoryTree.items.push({
            //     slug: "casy",
            //     label: "Часы",
            //     count: 3,
            //     items: casy
            //   })
            // }
            
          })
          .catch((error) => {
            console.log(error)
          });
    },
    getProducts() {
      this.isCategoriesSidebarOpen = false
      const data = {};

      if(this.$route.params.category) {
        data.category = this.$route.params.category;
        axios.post(`/category_analytics/${this.$route.params.shop}`, {
          category_id: data.category
        })
      }

      data.minPrice = this.filtersValues.price[0]
      data.maxPrice = this.filtersValues.price[1]

      for(let fv in this.filtersValues) {
        console.log(fv, this.filtersValues[fv])
        if(this.filtersValues[fv]) {
          data[fv] = this.filtersValues[fv]
        }
      }

      delete data.price

      data.sortBy = this.sortBy.selected;

      data.shop = this.$route.params.shop;

      data.page = this.pagination.currentPage

      axios.get(`/products`, {
        params: data
      })
          .then((result) => {
            const { data, current_page, last_page, total } = result.data;
            this.products = data;

            this.pagination.totalItems = total;
            this.pagination.totalPages = last_page;
            this.pagination.currentPage = current_page;

            this.loading = false;
          })
          .catch((error) => {
            console.log(error)
          });
    },
    setCurrentPage(value) {
      this.$router.push({
        name: 'shop',
        params: {
          category: this.$route.params.category
        },
        query: {
          page: value
        }
      })
      this.loading = true
      window.scrollTo(0, 0)
      this.pagination.currentPage = value;
    },

    toggleFilterSidebar() {
      this.isFilterSidebarOpen = !this.isFilterSidebarOpen
    },
    toggleCategoriesSidebar() {
      this.isCategoriesSidebarOpen = !this.isCategoriesSidebarOpen
    },

    changeSorting(value) {
      console.log(value);
      this.sortBy.selected = value;
      this.getProducts();
    },

    addToWishlist() {

    },

    changeItemsPerPage(value) {
      this.pagintation.itemsPerPage = value;
    },

    isFilterSelected(filter, value) {
      return this.filtersValues[filter.id] === value.value;
    },

    selectFilter(filter, value) {
      if(this.filtersValues[filter.id] === value.value) {
        this.filtersValues[filter.id] = null;
      } else {
        this.filtersValues[filter.id] = value.value;
      }
    },

    getDefaultImage(image) {
      console.log(image)
      return `${process.env.VUE_APP_STORAGE}/${image}`
    },

    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },

    applyFilters() {
      this.getProducts()
      this.isFilterSidebarOpen = false
    },

    clearFilters() {
      this.filtersValues = {
        metal: null,
        insert: null,
        'insert-color': null
      }
      this.applyFilters()
    },
    async getBanners() {
      await axios.get(`${process.env.VUE_APP_API_URL}/settings/banners`)
          .then((result) => {
            const data = result.data;

            this.banners[0].image = {
              desktop: process.env.VUE_APP_STORAGE + "/" + data[2].desktop_image,
              mobile: process.env.VUE_APP_STORAGE + "/" + data[2].mobile_image
            };

            this.banners[1].image = {
              desktop: process.env.VUE_APP_STORAGE + "/" + data[3].desktop_image,
              mobile: process.env.VUE_APP_STORAGE + "/" + data[3].mobile_image
            };

            this.banners[2].image = {
              desktop: process.env.VUE_APP_STORAGE + "/" + data[4].desktop_image,
              mobile: process.env.VUE_APP_STORAGE + "/" + data[4].mobile_image
            };

            this.bannersLoading = false;
          })
          .catch((error) => {
            console.log(error)
          });
    },

    searchProducts() {
      this.filtersValues = {
        metal: null,
        insert: null,
        'insert-color': null,
        carat: null,
        stone_cut: null,
        probe: null,
        forWho: null,
        style: null,
        type: null,
        size: null,
        search: this.filtersValues.search,
        length: null,
        price: [
          0, 50000000
        ]
      }

      this.loading = true
      this.getProducts()
    }
  },

  computed: {
    ...mapGetters({
      isOnWishlist: 'isOnWishlist'
    }),
  }
}
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  flex-direction: column;
  align-items: 
  flex-start;
  width: 100%;

  &__top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 30px;

    @media (min-width: 768px) {
      flex-direction: row;
    }
  }
  &__middle {
    flex-direction: column;
    align-items: center !important;
    @include for-desktop { 
      flex-direction: row;
      justify-content: space-between;
      align-items: center !important;
    }
    .location {
      font-size: 14px;
      iframe {
        max-width: 500px;
        width: 100%;
        height: 300px;
      }
    }

    .work_time {
      font-size: 15px;
      font-weight: 600;
    }
  }
  &__bottom {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    text-align: justify;
  }

  &__logo {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    max-width: 50%;

    @media (min-width: 768px) {
      max-width: 100%;
      flex: 2;
    }
    img {
      width: 80%;
    }
  }

  &__banner-wrapper {
    overflow: hidden;
    position: relative;
    flex: 1;
    margin-top: 30px;
    display: flex;
    align-items: center;

    font-size: 24px;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-align: center;

    @media (min-width: 768px) {
      flex: 10;
      margin-top: 0;
    }
  }
}
#category {
  box-sizing: border-box;
  @include for-desktop {
    max-width: 1240px;
    margin: 0 auto;
  }
}
.main {
  &.section {
    padding: var(--spacer-xs);
    @include for-desktop {
      padding: 0;
    }
  }
}
.breadcrumbs {
  margin: var(--spacer-base) auto var(--spacer-lg);
}
.navbar {
  position: relative;
  display: flex;
  border: 1px solid var(--c-light);
  border-width: 0 0 1px 0;
  @include for-desktop {
    border-width: 1px 0 1px 0;
  }
  &.section {
    padding: var(--spacer-sm);
    @include for-desktop {
      padding: 0;
    }
  }
  &__aside,
  &__main {
    display: flex;
    align-items: center;
    padding: var(--spacer-sm) 0;
  }
  &__aside {
    flex: 0 0 15%;
    padding: var(--spacer-sm) var(--spacer-sm);
    border: 1px solid var(--c-light);
    border-width: 0 1px 0 0;
  }
  &__main {
    flex: 1;
    padding: 0;
    @include for-desktop {
      padding: var(--spacer-xs) var(--spacer-xl);
    }
  }
  &__title {
    --heading-title-font-weight: var(--font-weight--semibold);
    --heading-title-font-size: var(--font-size--xl);
  }
  &__filters-icon {
    margin: 0 var(--spacer-xs) 0 0;
  }
  &__filters-button {
    display: flex;
    align-items: center;
    --button-font-size: var(--font-size--base);
    --button-text-decoration: none;
    --button-color: var(--c-link);
    --button-font-weight: var(--font-weight--normal);
    @include for-mobile {
      order: 1;
    }
    svg {
      fill: var(--c-text-muted);
      transition: fill 150ms ease;
    }
    &:hover {
      svg {
        fill: var(--c-primary);
      }
    }
  }
  &__label {
    font-family: var(--font-family--secondary);
    font-weight: var(--font-weight--normal);
    color: var(--c-link);
    margin: 0 var(--spacer-2xs) 0 0;
  }
  &__select {
    --select-width: 220px;
    --select-padding: 0;
    --select-height: auto;
    --select-selected-padding: 0 var(--spacer-lg) 0 var(--spacer-2xs);
    --select-margin: 0;
    --select-option-font-size: var(--font-size-sm);
    --select-error-message-height: 0;
    ::v-deep .sf-select__dropdown {
      font-size: var(--font-size-sm);
      font-family: var(--font-family--secondary);
      font-weight: var(--font-weight--light);
      margin: 0;
    }
    ::v-deep .sf-select__placeholder {
      --select-option-font-size: var(--font-size-sm);
    }
  }
  &__sort {
    display: flex;
    align-items: center;
    margin: 0 auto 0 var(--spacer-2xl);
  }
  &__counter {
    font-family: var(--font-family--secondary);
    margin: auto;
    @include for-desktop {
      margin: auto 0 auto auto;
    }
  }
  &__view {
    display: flex;
    align-items: center;
    margin: 0 var(--spacer-xl);
    @include for-desktop {
      margin: 0 0 0 var(--spacer-2xl);
    }
    &-icon {
      cursor: pointer;
      margin: 0 var(--spacer-base) 0 0;
      &:last-child {
        margin: 0;
      }
    }
    &-label {
      margin: 0 var(--spacer-sm) 0 0;
      font: var(--font-weight--normal) var(--font-size--base) / 1.6
        var(--font-family--secondary);
      text-decoration: none;
      color: var(--c-link);
    }
  }
}
.sort-by {
  flex: unset;
  width: 11.875rem;
}
.main {
  display: flex;
}
.sidebar {
  flex: 0 0 15%;
  padding: var(--spacer-sm);
  border: 1px solid var(--c-light);
  border-width: 0 1px 0 0;
}
.sidebar-filters {
  --sidebar-title-display: none;
  --sidebar-top-padding: 0;
  @include for-desktop {
    --sidebar-content-padding: 0 var(--spacer-xl);
    --sidebar-bottom-padding: 0 var(--spacer-xl);
  }
}
.list {
  --menu-item-font-size: var(--font-size--sm);
  &__item {
    &:not(:last-of-type) {
      --list-item-margin: 0 0 var(--spacer-sm) 0;
    }
  }
}
.products {
  box-sizing: border-box;
  flex: 1;
  margin: 0;
  &__grid,
  &__list {
    display: flex;
    flex-wrap: wrap;
  }
  &__product-card {

  }
  &__product-card-horizontal {
    flex: 0 0 100%;
  }
  &__slide-enter {
    opacity: 0;
    transform: scale(0.5);
  }
  &__slide-enter-active {
    transition: all 0.2s ease;
    transition-delay: calc(0.1s * var(--index));
  }
  @include for-desktop {
    &__grid {
      margin: var(--spacer-sm) 0 0 var(--spacer-sm);
    }
    &__pagination {
      display: flex;
      justify-content: flex-start;
      margin: var(--spacer-xl) 0 0 0;
    }
    &__product-card-horizontal {
      margin: var(--spacer-lg) 0;
    }
    &__product-card {
      flex: 1 1 25%;
    }
    &__list {
      margin: 0 0 0 var(--spacer-sm);
    }
  }
  &__show-on-page {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    &__label {
      font-family: var(--font-family--secondary);
      font-size: var(--font-size--sm);
    }
  }
}
.loading {
  margin-top: 100px;
}
.filters {
  &__title {
    --heading-title-font-size: var(--font-size--xl);
    margin: var(--spacer-xl) 0 var(--spacer-base) 0;
    &:first-child {
      margin: calc(var(--spacer-xl) + var(--spacer-base)) 0 var(--spacer-xs) 0;
    }
  }
  &__colors {
    display: flex;
  }
  &__color {
    margin: var(--spacer-xs) var(--spacer-xs) var(--spacer-xs) 0;
  }
  &__chosen {
    color: var(--c-text-muted);
    font-weight: var(--font-weight--normal);
    font-family: var(--font-family--secondary);
    position: absolute;
    right: var(--spacer-xl);
  }
  &__item {
    --radio-container-padding: 0 var(--spacer-sm) 0 var(--spacer-xl);
    --radio-background: transparent;
    --filter-label-color: var(--c-secondary-variant);
    --filter-count-color: var(--c-secondary-variant);
    --checkbox-padding: 0 var(--spacer-sm) 0 var(--spacer-xl);
    padding: var(--spacer-sm) 0;
    border-bottom: 1px solid var(--c-light);
    &:last-child {
      border-bottom: 0;
    }
    @include for-desktop {
      --checkbox-padding: 0;
      margin: var(--spacer-sm) 0;
      border: 0;
      padding: 0;
    }
  }
  &__accordion-item {
    --accordion-item-content-padding: 0;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    width: 100vw;
  }
  &__buttons {
    margin: var(--spacer-sm) 0;
  }
  &__button-clear {
    --button-background: var(--c-light);
    --button-color: var(--c-dark-variant);
    margin: var(--spacer-xs) 0 0 0;
  }
}

.products__pagination {
  justify-content: center;
}

.sf-banner {
  @media (min-width: 768px) {
    --banner-background-image: var( --_banner-background-desktop-image, var(--_banner-background-image) );
  }
}

.banner-grid {
  --banner-container-width: 50%;
  margin: var(--spacer-xl) 0;
  @include for-desktop {
    margin: var(--spacer-2xl) 0;
  }
}



.banner {
  &__tshirt {
    background-position: left;
  }
  &-central {
    @include for-desktop {
      --banner-container-flex: 0 0 70%;
    }
  }
}

.sf-banner {
  @include for-desktop {
    min-height: unset;
    height: 0;
    padding-bottom: 17%;
    margin-top: 30px;
  }
}
</style>

<style lang="scss">
.page-catalog {
  .banner {
    .location {
      max-width: 500px;
      width: 100%;
      iframe {
        max-width: 500px;
        width: 100%;
        height: 300px;
      }
    } 
  }
  
}

.sidebar-main {
  .sf-accordion-item {
    & > div {
      height: auto !important;
    }
  }
}

.sidebar-filters-catalog {
  .sf-accordion-item__content {
    padding-bottom: 100px;
  }
}
</style>